import { render, staticRenderFns } from "./churn-subscription.vue?vue&type=template&id=d85680c4&functional=true&"
import script from "./churn-subscription.vue?vue&type=script&lang=js&"
export * from "./churn-subscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports